import type { ReactNode } from 'react';
import { useSecondsUntil } from '../hooks/useNow.ts';

/**
 * A ticking number, isolated. Only this component re-renders as the seconds
 * fall, so a countdown on the table does not re-render the table.
 */
export function Countdown({
  until,
  children,
}: {
  until: number | null;
  children: (seconds: number) => ReactNode;
}) {
  const seconds = useSecondsUntil(until);
  return <>{children(seconds)}</>;
}
